// extracted by mini-css-extract-plugin
export default {"external":"apvXgU","hideChips":"bpvXgU","deliveryChips":"cpvXgU"};